import { render, staticRenderFns } from "./svgLocation.vue?vue&type=template&id=28060544&scoped=true"
import script from "./svgLocation.vue?vue&type=script&lang=js"
export * from "./svgLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28060544",
  null
  
)

export default component.exports